import {
  useGuestAuth,
  useManualQueryRequest,
  useMutationRequest,
  useQueryRequest,
} from '../../../modules/hooks';
import type {
  CardInfo,
  DynamicQuestionPayload,
  GuestsRequest,
  MewsReservationResponse,
  ReservationRatingResponse,
} from '../../../modules/interfaces';
import { endpoints } from '../../../modules/mappers/urls';
import { buildRequestUrl } from '../../../modules/utils/buildRequestUrl';

export const useGetReservation = (reservationId: string) => {
  const { token } = useGuestAuth()!;
  const getReservationUrl = `${endpoints.RESERVATION}/${reservationId}`;

  return useManualQueryRequest<MewsReservationResponse>(
    getReservationUrl,

    {
      authGuestToken: token,
    },
    { manual: true },
  );
};

export const useGetReservation2 = (reservationId: string) => {
  const { token } = useGuestAuth()!;
  const getReservationUrl = `${endpoints.RESERVATION}/${reservationId}`;

  return useManualQueryRequest<MewsReservationResponse>(
    getReservationUrl,
    {
      authGuestToken: token,
    },
    { manual: true },
  );
};

export const useGuestReservation = (reservationId: string) => {
  const { token } = useGuestAuth()!;

  const getReservationUrl = `${endpoints.GUESTS}/${reservationId}`;
  return useManualQueryRequest<GuestsRequest>(
    getReservationUrl,

    {
      authGuestToken: token,
    },
    { manual: true },
  );
};

export const useAddPackagesToGuest = (propertyId?: string) => {
  const { token } = useGuestAuth()!;

  const getReservationUrl = `${endpoints.GUESTS}/request-packages`;
  return useMutationRequest<GuestsRequest>(
    getReservationUrl,
    'put',
    {
      authGuestToken: token,
      propertyId,
    },
    { manual: true },
  );
};

export const useGetCardInfo = () => {
  const { token } = useGuestAuth()!;

  const url = endpoints.GET_DEFAULT_PAYMENT_METHOD;
  return useManualQueryRequest<CardInfo>(
    url,
    {
      authGuestToken: token,
    },
    { manual: true },
  );
};

export const useGetAccessCode = (reservationId: string) => {
  const { token } = useGuestAuth()!;

  const urlAccessCode = `${endpoints.RESERVATION}/${reservationId}/access-code`;
  return useManualQueryRequest<string>(
    urlAccessCode,

    {
      authGuestToken: token,
    },
    { manual: true },
  );
};

export const useGetReservationRating = (reservationId: string) => {
  const { token } = useGuestAuth()!;

  const URL = `${endpoints.RATING}/${reservationId}`;
  return useManualQueryRequest<ReservationRatingResponse>(
    URL,

    {
      authGuestToken: token,
    },
    {
      manual: true,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );
};

export const useGetDynamicQuestions = (propertyId: string, reservationId: string) => {
  const { token } = useGuestAuth()!;

  const getReservationUrl = buildRequestUrl(
    endpoints.DYNAMIC_QUESTION_ANSWERS_BY_RESERVATION,
    {
      propertyId,
      reservationId,
    },
  );
  return useQueryRequest<DynamicQuestionPayload[]>(getReservationUrl, {
    authGuestToken: token,
  });
};
